// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".break-word[data-v-4ef33ddf]{overflow-wrap:break-word;word-wrap:break-word;-webkit-hyphens:auto;hyphens:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
